import ArquivoFilaProcessamentoService from '@/services/ArquivoFilaProcessamentoService';

const cadastrarArquivoFilaProcessamento = (vm, tipoArquivo, data) => {
  return ArquivoFilaProcessamentoService.cadastrarSolicitacao(tipoArquivo, data).then((response) => {
    // Mostrar alerta visual temporário
    vm.$notify.success({
      title: 'Solicitação Realizada',
      message: 'Seu relatório está sendo gerado! Você receberá um e-mail quando estiver pronto e também poderá baixá-lo através do ícone de notificações no menu superior.',
      duration: 8000,
      position: 'top-right'
    });
  }).catch((error) => {
    let chaveMensagemErro = (error.response && error.response.data === 'ERRO_USUARIO_SEM_EMAIL') ? 'mensagens.arquivoFilaProcessamento.erroCadastrarSolicitacaoUsuarioSemEmail' : 'mensagens.arquivoFilaProcessamento.erroCadastrarSolicitacao';
    vm.$notify.error({
      message: vm.$t(chaveMensagemErro),
      duration: 10000
    });
    throw error;
  });
};

export default {
    cadastrarArquivoFilaProcessamento
};
